export default {
  country_locale: 'fi-FI',
  wia_contact_links: {
    ID: 'https://www.indesit.fi/Indesit-Support/Yhteydenottolomake',
    WP: 'https://www.whirlpool.fi/Ota-yhteyttae/Har-du-brug-for-hjaelp-1/Ota-meihin-yhteyttae'
  },
  wia_title: 'Verkkopalvelu ongelman selvitykseen',
  wia_need_help: 'Ongelmankuvaus',
  wia_model_name: 'Mallin nimi on',
  wia_back: '< muuta',
  wia_confirm: 'Vahvista',
  wia_issue_title: 'Mikä on ongelmana?',
  wia_issue_concern: 'Ongelmani koskee',
  wia_issue_specific: 'Ongelman täsmennys',
  wia_possible_solution: 'Mahdollisia ratkaisuja',
  wia_solved_issue: 'Korjaantuiko ongelma?',
  wia_closed: 'Sulje X',
  wia_feedback_ok: 'Kyllä!',
  wia_find_another_solution: 'Etsi toinen ratkaisu',
  wia_feedback_title: 'Hienoa että ongelma korjaantui!',
  wia_feedback_text1: 'Vieraile verkkokaupassamme ja löydä erikoistarjouksemme',
  wia_feedback_text2: 'Tutustu uusimpiin tuotteisiimme',
  wia_smile_up_popup_text1: 'Lue lisää jatkoturva palveluista',
  wia_smile_down_popup_title: 'Tarvitsetko lisäapua?',
  wia_smile_down_popup_text1: 'Seuraava vaihe',
  wia_smile_down_popup_or_text: 'tai',
  wia_smile_down_popup_text2: 'Tilaa huolto',
  wia_need_more_help: 'Tarvitsetko lisäapua?',
  wia_optional_label: '(valinnainen)',
  wia_no_solution: 'Valitettavasti palvelussamme ei ole ongelmankuvaukseenne sopivaa itsekorjausehdotusta. Paina tästä saadaksesi lisäapua.',
  wia_all_solution: 'Kaikki vaihtoehdot',
  wia_all_categories: 'Kaikki kategoriat',
  wia_seo_l1_issue: 'Kaikki ongelmat kategorian mukaan',
  wia_seo_wp_country_name: 'FI',
  wia_seo_bk_country_name: 'FI',
  wia_seo_hp_country_name: 'FI',
  wia_seo_id_country_name: 'FI',
  wia_seo_wp_meta_title: 'Ongelmia ja ratkaisuja',
  wia_seo_bk_meta_title: 'Ongelmia ja ratkaisuja',
  wia_seo_hp_meta_title: 'Ongelmia ja ratkaisuja',
  wia_seo_id_meta_title: 'Ongelmia ja ratkaisuja',
  wia_seo_wp_meta_description_home: 'Selvitä laiteongelmat Whirlpool verkkopalvelun avulla',
  wia_seo_bk_meta_description_home: 'Selvitä laiteongelmat Bauknecht verkkopalvelun avulla',
  wia_seo_hp_meta_description_home: 'Selvitä laiteongelmat Hotpoint verkkopalvelun avulla',
  wia_seo_id_meta_description_home: 'Selvitä laiteongelmat Indesit verkkopalvelun avulla',
  wia_issue_search: 'Mikä on ongelmana?',
  wia_issue_description: 'Kerro lyhyesti pääongelma laitteessasi',
  wia_issue_placeholder: 'Esim. vuotaa vettä laitteen alta',
  wia_issue_generic_macro_category: 'Yleistä',
  wia_issue_no_results: 'Hakutuloksia ei löytynyt',
  wia_issue_search_label: 'Etsi',
  wia_related_solution: 'Muita vastaavia ratkaisuja',
  wia_seo_wp_meta_description: 'Selvitä laiteongelmasi syy muutamalla painauksella European Appliances Finland verkkopalvelun avulla',
  wia_seo_bk_meta_description: 'Selvitä laiteongelmasi syy muutamalla painauksella European Appliances Finland verkkopalvelun avulla',
  wia_seo_hp_meta_description: 'Selvitä laiteongelmasi syy muutamalla painauksella European Appliances Finland verkkopalvelun avulla',
  wia_seo_id_meta_description: 'Selvitä laiteongelmasi syy muutamalla painauksella Indesit verkkopalvelun avulla'
}
